import React from 'react'
import { com } from '@eidu/web'
import { Text } from '@common/ui'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import EntityFieldDisplayRow from './EntityFieldDisplayRow'
import Field = com.eidu.entity.field.Field

export type EntityFormNumberDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormNumberDisplay = ({ field, fieldValue }: EntityFormNumberDisplayProps) => (
  <EntityFieldDisplayRow field={field}>
    <Text size="sm">{fieldValue?.value ?? ''}</Text>
  </EntityFieldDisplayRow>
)

export default EntityFormNumberDisplay
